import { render, staticRenderFns } from "./LmBreadcrumb.vue?vue&type=template&id=1b124b6e&scoped=true"
import script from "./LmBreadcrumb.vue?vue&type=script&lang=js"
export * from "./LmBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./LmBreadcrumb.vue?vue&type=style&index=0&id=1b124b6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b124b6e",
  null
  
)

export default component.exports